import React, { useState } from 'react'
import { icosIndicators } from '../../../../app/Paths'
import { TableTotals } from '../../../../components/Tables/TableTotals';
import { FiAlertTriangle, FiEye, FiRefreshCcw, FiSearch } from 'react-icons/fi';
import { orders_status, orders_status_colors } from '../../../../app/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { loadOrderDetail, loadOrders, loadOrdersByDevice } from '../../../store/Thunk';
import { Table } from '../../../../components/Tables/Table';
import { M_Detail } from './M_Detail';
import { Link } from 'react-router-dom';


export const Orders = () => {
  
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (value) => {
    setShowModal(true);
    dispatch(loadOrderDetail(value))
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  const { isLoading, idCustomer, orders, devices } = useSelector(state => state.customerDetail);
  const { register: registerSearch, handleSubmit: handleSubmitSearch, resetField: resetFieldSearch, formState: { errors: errorsSearch } } = useForm({ model: 'all' });

  const listOrders = [...orders];

  let columns = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-center',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
      // renderer: (value, row) => (
      //   <>
      //     <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(row.FOLIO); handleOpenModal(row.FOLIO); }} >{value}</button>
      //   </>
      // ),
       renderer: (value, row) => (
        <Link to={`/trackingOrder/${value}`}>
          {value}
        </Link>
      ),
    },
    {
      header: 'TECNICO',
      dataIndex: 'TECNICO_ASIGNADO',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'EQUIPO',
      dataIndex: 'EQUIPO',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'FALLA',
      dataIndex: 'FALLA',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'INGRESO',
      dataIndex: 'F_RECIBIDO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'ASIGNACION',
      dataIndex: 'F_ASIGNACION',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'ENTREGA',
      dataIndex: 'F_CERRADA',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'ESTADO',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isAction: true,
      isTotal: false, // 👈 sumará esta columna
      renderer: (value) => {
        const code = Number(value);
        return (
          <span className={`badge text-white ${orders_status_colors[code]}`}>
            {orders_status[code]}
          </span>
        );
      }
    },
    {
      header: 'ACCIONES',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isAction: true,
      renderer: (value, row) => {
        const isDeleted = Number(row.ESTADO) === 0;
        return (
          <button type="button" className="btn btn-outline-dark border-0" onClick={() => { setSelectedItem(row.FOLIO); handleOpenModal(row.FOLIO); }} title="Ver detalles">
            <FiEye size={18} />
          </button>
        );
      }
    }
  ];

  const handledsearchGeneral = () => {
    resetFieldSearch('equipo_id');
    dispatch(loadOrders(idCustomer));
  }

  const findOrdersByDevice = (data) => {
    let equipo = data.equipo_id;
    dispatch(loadOrdersByDevice(idCustomer, equipo));
  }

  return (
    <>
      {showModal && (<M_Detail onClose={handleCloseModal} selectedItem={selectedItem}/>)}
      <div className='row'>
        <div className='col-12 mb-3'>
          <img src={icosIndicators['orders']} className="img-fluid" width={28} alt="sales" />
          <span className='ms-2 me-3 fw-bold h4'>Ordenes de Servicio</span>
        </div>

        <div className='col-12 mb-3'>
          <form className="w-50" onSubmit={handleSubmitSearch(findOrdersByDevice)} role="search">
            <label> Filtrar por equipo:</label>
            <div className='d-flex'>
              <select className="form-select" {...registerSearch("equipo_id", { required: 'Seleccione equipo' })} >
                <option value="" >Seleccione un equipo</option>
                {
                  devices.length == 0 ? <option value="">No hay equipos asociados al cliente</option> :
                    devices.map((item, index) => (<option key={index} value={item.ID} className='text-uppercase' >{item.CATEGORIA} {item.MARCA} {item.NO_SERIE}</option>))
                }
              </select>
              <button className="btn btn-outline-primary ms-2" type="submit"> <FiSearch size="20" /> </button>
              <button className="btn btn-outline-dark ms-2" type="button" onClick={handledsearchGeneral}> <FiRefreshCcw size="20" /> </button>
            </div>
            {
              errorsSearch.equipo_id &&
              <div className='text-left-5 mt-1 '>
                <FiAlertTriangle size="18" color="#dc3545" />
                <span className='text-left-10 fw-bold text-danger'><small>{errorsSearch.equipo_id.message}</small></span>
              </div>
            }
          </form>
        </div>

        <div className='col-12'>
          <Table
            columns={columns}
            data={listOrders}
            function_={(row) => { setSelectedItem(row.ID) }}
            placeholderSearch="Buscar por: ID, Tipo, Marca, Sistema operativo"
            showPagination={true}
            showControls={true}
            showTotals={false}
          />
        </div>
      </div>
    </>
  )
}
